import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Button, Card, CardHeader, CardContent, Box, Typography, } from '@mui/material';
import RoasterAddressSelect from '../../organisms/RoasterAddress/RoasterAddressSelect';
var DeliveryRequestsAddressForm = function (_a) {
    var roaster = _a.roaster, address = _a.address, onChangeAddress = _a.onChangeAddress, isAdmin = _a.isAdmin;
    var t = useTranslation().t;
    var _b = React.useState(false), editAddress = _b[0], setEditAddress = _b[1];
    return (React.createElement(React.Fragment, null, address && !editAddress ? (React.createElement(Card, { sx: { mb: 2 } },
        React.createElement(CardHeader, { title: t('labels.deliveryAddress'), action: React.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" },
                React.createElement(Button, { color: "secondary", variant: "outlined", size: "small", onClick: function () { return setEditAddress(true); } }, t('edit'))) }),
        React.createElement(CardContent, null,
            React.createElement(Grid, { container: true, spacing: 1, alignItems: "center" }, [
                'storeName',
                'personName',
                'nameKana',
                'postalCode',
                'prefecture',
                'city',
                'address',
                'building',
                'phone',
            ].map(function (field) {
                return (React.createElement(React.Fragment, { key: field },
                    React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                        React.createElement(Typography, { variant: "subtitle1" },
                            t("params.deliveryRequest.".concat(field)),
                            " :")),
                    React.createElement(Grid, { item: true, xs: 12, sm: 9, style: { wordBreak: 'break-all' } }, address[field])));
            }))))) : (React.createElement(RoasterAddressSelect, { role: isAdmin ? 'admin' : 'roaster', type: "delivery", roaster: roaster, onChange: onChangeAddress }))));
};
export default DeliveryRequestsAddressForm;
